const getConfirmationTimeoutDuration = () => {
    const secondsToTimeout = 10;
    return 1000 * secondsToTimeout;
};

export default { getConfirmationTimeoutDuration };
